
<template>
  <!--位置管理-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="positionId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      @resetSearch = 'resetHandle'
    >
      <template slot="opt_o" slot-scope="{row}">
        <a-tooltip placement="topLeft" :title="row.categoryFullName">
          <span :style="{cursor: 'pointer'}">{{row.categoryName}}</span>
        </a-tooltip>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'location',
  data () {
    return {
      cascadeParam: {},
      searchList: [
        { props: [`${this.$route.name}/communityId`], placeholder: '小区', options: [], inputType: 'select', handle: ($event) => this.communityChange(7, $event), fetchOptions: this.getOptions },
        { props: ['keywords'], placeholder: '名称', options: [], inputType: 'input' },
        { props: ['categoryId'], placeholder: '分类', options: [], inputType: 'cascader' },
        { props: ['isStrictly'], placeholder: '是否受限', options: this.$store.state.booleanList, inputType: 'select' },
        { props: ['createDate'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' },
        {
          props: ['areas'],
          placeholder: '省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(5, 'searchList', '1,2,3', e);
          }
        },
        { props: ['propertyId'], placeholder: '物业公司', options: [], inputType: 'select' },
        { props: [`${this.$route.name}/buildingId`], placeholder: '楼栋', options: [], inputType: 'select', handle: ($event) => this.buildingChange(8, $event) },
        { props: [`${this.$route.name}/unitId`], placeholder: '单元', options: [], inputType: 'select' }
      ],
      searchParams: {
        [`${this.$route.name}/communityId`]: undefined,
        keywords: undefined,
        categoryId: undefined,
        isStrictly: undefined,
        createDate: undefined,
        areas: undefined,
        propertyId: undefined,
        [`${this.$route.name}/buildingId`]: undefined,
        [`${this.$route.name}/unitId`]: undefined
      },
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:position:add'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:position:remove'] }
      ],
      rowOptList: [
        { text: '修改', handle: (row) => this.$refs.table.toEdit(row, ['canDelete']), permi: ['community:position:edit'] },
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['community:position:remove'] }
      ],
      columns: [
        { title: '所在城市', dataIndex: 'area', align: 'left', width: '' },
        { title: '位置', dataIndex: 'address', align: 'left', width: '' },
        { title: '名称', dataIndex: 'positionName', align: 'left', width: '' },
        { title: '所属分类', dataIndex: 'categoryName', align: 'left', width: '', scopedSlots: {customRender: 'o'} },
        { title: '是否受限', dataIndex: 'strictDesc', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/position/list',
        resHandle: '',
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addLocation',
        addTitle: '新增位置',
        editTitle: '修改位置'
      },
      deleteParam: {
        url: '/position/',
        // param: { pk_key: 'position_id', pk_val: '' },
        title: '位置',
        key: 'address'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    resetHandle () {
      this.searchList[7].options = [];
      this.searchList[8].options = [];
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    /* 获取下拉 */
    getSelect () {
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
      this.regionSelect(5);
      this.propertySelect(6);
      this.dictionarySelect([{index: 2, scope: 'searchList', query: 'comu_position_type'}]);
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
